var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec10, _dec11, _dec12, _dec13, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _JournalEventModel;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import Model, { attr, belongsTo, hasMany } from "@ember-data/model";
import { assert, warn } from "@ember/debug";
import { service } from "@ember/service";
import Creator from "core/models/creator";
import FileAttachment from "core/models/file-attachment";
import Patient from "core/models/patient";
import FetcherService from "core/services/fetcher";
import formatToISO8601Date from "core/utils/format-to-iso8601-date";
import { sortBy } from "core/utils/sort";
import Ember from "ember";
import { EmberChangeset } from "ember-changeset";
import lookupValidator from "ember-changeset-validations";
import IntlService from "ember-intl/services/intl";
import AlertTriggeredJournalEvent from "./alert-triggered-journal-event";
import NotificationTriggeredJournalEvent from "./notification-triggered-journal-event";
import PatientChatMessageSentJournalEvent from "./patient-chat-message-sent-journal-event";
let JournalEventModel = (_dec = attr("date"), _dec2 = attr("date"), _dec3 = attr("date"), _dec4 = attr("boolean", {
  defaultValue() {
    return false;
  }
}), _dec5 = attr("string"), _dec6 = belongsTo("patient", {
  async: false,
  inverse: "journalEvents",
  as: "journal-event"
}), _dec7 = belongsTo("creator", {
  async: false,
  inverse: null,
  polymorphic: true
}), _dec8 = belongsTo("journal-event", {
  async: false,
  polymorphic: true,
  inverse: "triggeredJournalEvents",
  as: "journal-event"
}), _dec9 = hasMany("alert-triggered-journal-event", {
  async: false,
  inverse: "triggeringJournalEvent",
  as: "journal-event"
}), _dec10 = hasMany("notification-triggered-journal-event", {
  async: false,
  inverse: "triggeringJournalEvent",
  as: "journal-event"
}), _dec11 = belongsTo("patient-chat-message-sent-journal-event", {
  async: false,
  inverse: "triggeringJournalEvent",
  as: "journal-event"
}), _dec12 = hasMany("journal-event", {
  async: false,
  polymorphic: true,
  inverse: "originJournalEvent",
  as: "journal-event"
}), _dec13 = hasMany("file-attachment", {
  async: false,
  inverse: "journalEvent",
  as: "journal-event"
}), _class = (_JournalEventModel = class JournalEventModel extends Model {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "fetcher", _descriptor, this);
    _initializerDefineProperty(this, "occurredAt", _descriptor2, this);
    _initializerDefineProperty(this, "createdAt", _descriptor3, this);
    _initializerDefineProperty(this, "updatedAt", _descriptor4, this);
    _initializerDefineProperty(this, "isArchived", _descriptor5, this);
    _initializerDefineProperty(this, "comments", _descriptor6, this);
    _initializerDefineProperty(this, "patient", _descriptor7, this);
    _initializerDefineProperty(this, "creator", _descriptor8, this);
    _initializerDefineProperty(this, "originJournalEvent", _descriptor9, this);
    _initializerDefineProperty(this, "alertTriggeredJournalEvents", _descriptor10, this);
    _initializerDefineProperty(this, "notificationTriggeredJournalEvents", _descriptor11, this);
    _initializerDefineProperty(this, "patientChatMessageSentJournalEvent", _descriptor12, this);
    _initializerDefineProperty(this, "triggeredJournalEvents", _descriptor13, this);
    _initializerDefineProperty(this, "fileAttachments", _descriptor14, this);
    _initializerDefineProperty(this, "intl", _descriptor15, this);
  }
  get orderedFileAttachments() {
    return this.fileAttachments.toSorted(sortBy("index"));
  }
  get latestFileAttachment() {
    return this.orderedFileAttachments.at(-1);
  }
  static patientJournalEventsRequest(fetcher, patientId, jeTypesToFetch, jeTypesToIgnore, occurredAfter, useQuery = false) {
    const filter = {
      patient_id: patientId
    };
    if (jeTypesToFetch) {
      filter["type"] = jeTypesToFetch;
    }
    if (jeTypesToIgnore) {
      filter["not_of_type"] = jeTypesToIgnore;
    }
    if (occurredAfter) {
      filter["occurred_at_gte"] = formatToISO8601Date(occurredAfter);
    }
    const method = useQuery ? "query" : "loadRecords";
    return fetcher[method]("journal-event", {
      filter,
      include: "creator"
    });
  }

  /**
   * Is there at least one alert triggered by this JE
   */
  get isAlertingJournalEvent() {
    return this.alertTriggeredJournalEvents.length > 0;
  }
  async archive(editedJournalEvent) {
    assert("Store is not set on the model.", Boolean(this.store));
    assert("To be archived, the JE needs an ID.", !this.isNew);
    assert("You can't archive a JE already archived", !this.isArchived);
    if (this.isArchived) {
      throw `The archived journal event '${this.id}' cannot be archived again.`;
    }
    if (!Ember.testing) {
      warn("JE has unsaved properties, might be lost when archived.", Boolean(this.hasDirtyAttributes), {
        id: "parog-web.journal-event.archiving-dirty"
      });
    }
    this.isArchived = true;
    if (editedJournalEvent) {
      await editedJournalEvent.save();
    }
    await this.save();
    this.triggeredJournalEvents.forEach(je => {
      this.store.unloadRecord(je);
    });

    // Reload journal events for the patient as new JeArchiveJEs may have been
    // created in the back (see Archivable#save! in the back).
    if (this.patient) {
      await JournalEventModel.patientJournalEventsRequest(this.fetcher, this.patient.get("id"));
    }
  }
  get description() {
    return this.intl.t(`journal-events.${this.constructor.type}`);
  }
  get summary() {
    return {
      type: this.constructor.type,
      /** The description to display in the timeline */
      description: this.description,
      /** The date to display. Can be undefined if no date should be displayed. */
      date: this.occurredAt ? this.occurredAt.toISOString() : undefined,
      /** Give access to the JE in the timeline */
      je: this,
      /** The form used for displaying the event content from the timeline */
      formId: null
    };
  }

  /**
   * This is an abstract property used by the timeline
   * to hide some JEs dynamically at run time.
   */
  get hideOnTimeline() {
    return false;
  }
  get occurredOn() {
    return new Date(this.occurredAt.getFullYear(), this.occurredAt.getMonth(), this.occurredAt.getDate());
  }
  createChangeset() {
    const validations = this.constructor.validations;
    return new EmberChangeset(this, lookupValidator(validations), validations);
  }
}, _defineProperty(_JournalEventModel, "validations", {}), _defineProperty(_JournalEventModel, "type", "journal-event"), _JournalEventModel), _descriptor = _applyDecoratedDescriptor(_class.prototype, "fetcher", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "occurredAt", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "createdAt", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "updatedAt", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isArchived", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "comments", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "patient", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "creator", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "originJournalEvent", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "alertTriggeredJournalEvents", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class.prototype, "notificationTriggeredJournalEvents", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class.prototype, "patientChatMessageSentJournalEvent", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class.prototype, "triggeredJournalEvents", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class.prototype, "fileAttachments", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { JournalEventModel as default };